(function () {
  'use strict';

  // ========================================
  // プロパティ正規化
  //   問題1: Shopify の line_item.properties | json が [["key","val"],...] 配列で出力される
  //   問題2: 旧注文は LEFT_KEY / RIGHT_KEY (prefix) 形式。新コードは KEY_LEFT / KEY_RIGHT (suffix) を期待
  //   → 両方を吸収して KEY_LEFT / KEY_RIGHT 形式に統一する
  // ========================================
  function normalizeProperties(rawProperties) {
    var obj = {};
    if (Array.isArray(rawProperties)) {
      rawProperties.forEach(function (pair) {
        if (Array.isArray(pair) && pair.length === 2) {
          obj[pair[0]] = pair[1];
        }
      });
    } else {
      obj = rawProperties || {};
    }

    var result = {};
    Object.entries(obj).forEach(function ([key, value]) {
      if (key.startsWith('LEFT_')) {
        result[key.slice(5) + '_LEFT'] = value;
      } else if (key.startsWith('RIGHT_')) {
        result[key.slice(6) + '_RIGHT'] = value;
      } else {
        result[key] = value;
      }
    });
    return result;
  }

  function classifyProperties(rawProperties) {
    var properties = normalizeProperties(rawProperties);
    var lensProperties = {};
    var prescriptionProperties = {};
    Object.entries(properties).forEach(function ([key, value]) {
      if (key.endsWith('_LEFT') || key.endsWith('_RIGHT')) {
        lensProperties[key] = value;
      } else {
        prescriptionProperties[key] = value;
      }
    });
    return { lensProperties: lensProperties, prescriptionProperties: prescriptionProperties };
  }

  // ========================================
  // レンズデータチェック
  // ========================================
  function isMissingValue(value) {
    return !value || value === '' || value === '未選択';
  }

  function checkLensData(config, lensProperties) {
    var variant = config.variants.find(function (v) {
      return v.id === config.selectedVariantId;
    });
    var isSingleBox = variant ? variant.isSingleBox : true;

    return config.expectedLensKeys.every(function (key) {
      if (isMissingValue(lensProperties[key + '_LEFT'])) return false;
      if (!isSingleBox && isMissingValue(lensProperties[key + '_RIGHT'])) return false;
      return true;
    });
  }

  // ========================================
  // レンズデータ表示
  // ========================================
  function formatLensDisplay(lensProperties, side) {
    return Object.entries(lensProperties)
      .filter(function ([key]) { return key.endsWith('_' + side); })
      .map(function ([key, value]) {
        var label = key.replace('_' + side, '').replace('BCDIA', 'BC/DIA');
        return label + '：' + value;
      })
      .join('、');
  }

  function renderLensDisplay(containerId, lensProperties) {
    var leftText = formatLensDisplay(lensProperties, 'LEFT');
    var rightText = formatLensDisplay(lensProperties, 'RIGHT');

    var scope = document.querySelector('[data-repurchase-container="' + containerId + '"]');
    if (!scope) return;

    var leftEl = scope.querySelector('.js-repurchase-product-lens-left');
    var rightEl = scope.querySelector('.js-repurchase-product-lens-right');

    if (leftEl) leftEl.textContent = leftText ? '左(L) - ' + leftText : '';
    if (rightEl) rightEl.textContent = rightText ? '右(R) - ' + rightText : '';
  }

  // ========================================
  // カート追加
  // ========================================
  function addToCart(config, lensProperties, prescriptionProperties) {
    var properties = Object.assign({}, lensProperties, prescriptionProperties);
    var item = {
      id: config.selectedVariantId,
      quantity: 1,
      properties: properties
    };
    if (config.isSubscription && config.selectedPlanId) {
      item.selling_plan = config.selectedPlanId;
    }

    fetch('/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'カートへの追加に失敗しました');
          });
        }
        window.location.href = '/cart';
      })
      .catch(function (error) {
        alert(error.message || 'カートへの追加に失敗しました。ページを再読み込みします。');
        location.reload();
      });
  }

  // ========================================
  // コンテナ単位の初期化
  // ========================================
  function setupContainer(scriptEl) {
    var config;
    try {
      config = JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('[RepurchaseProductButton] Failed to parse config:', e);
      return;
    }

    var containerId = config.containerId;
    var scope = document.querySelector('[data-repurchase-container="' + containerId + '"]');
    if (!scope) return;

    var _classified = classifyProperties(config.properties || {});
    var lensProperties = _classified.lensProperties;
    var prescriptionProperties = _classified.prescriptionProperties;

    var isLensOk = checkLensData(config, lensProperties);

    var okArea = scope.querySelector('.js-repurchase-product-ok-area');
    var fallback = scope.querySelector('.js-repurchase-product-fallback');

    if (isLensOk) {
      if (okArea) okArea.style.display = '';
      if (fallback) fallback.style.display = 'none';

      renderLensDisplay(containerId, lensProperties);

      var btn = scope.querySelector('.js-repurchase-product-btn');
      var isSubmitting = false;
      if (btn) {
        btn.removeAttribute('href');
        btn.onclick = function (e) {
          e.preventDefault();
          if (isSubmitting) return;
          isSubmitting = true;
          addToCart(config, lensProperties, prescriptionProperties);
        };
      }
    } else {
      if (okArea) okArea.style.display = 'none';
      if (fallback) fallback.style.display = '';
    }
  }

  // ========================================
  // 初期化
  // ========================================
  function init() {
    document.querySelectorAll('.js-repurchase-product-config').forEach(setupContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
